<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
        class="flex-wrap"
    >

    <v-toolbar-title>금교환 주문 리스트 </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-btn width="120px"
                color="blue"
                class='white--text'
                @click="checkBoxEnable_all()">선택하기</v-btn>
    <div style="width:10px"></div>


    <v-btn
        v-if="hasSelectedItems"
        width="120px"
        color="orange"
        class="white--text"
        @click="showBulkStateDialog = true"
    >상태변경</v-btn>
    </v-toolbar>

    <!-- 상태별 탭: 진행중(주문 완료·배송 대기·배송중) / 진행 완료(배송완료·취소·유저 취소) -->
    <v-tabs v-model="stateTab" color="primary" class="px-2">
        <v-tab>진행중 ({{ inProgressList.length }})</v-tab>
        <v-tab>진행 완료 ({{ completedList.length }})</v-tab>
    </v-tabs>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <div style="overflow-x: auto;">
    <v-data-table
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers"
        :items="visibleOrderList"
        :loading="loadingData"
        class="elevation-1 order-table"
        >        
        <template v-slot:item="row">            
            <tr :class="{'old-order': isAfterThisMonday(row.item.CREATE_DT)}">
                <td class="order-pid"><span>{{row.item.PID}}</span></td>
                <td class="order-address"><span>{{ [row.item.ZIPCODE ? '(' + row.item.ZIPCODE + ')' : '', row.item.ADDRESS, row.item.ADDRESS_DETAIL].filter(Boolean).join(' ') }}</span></td>
                <td class="order-amount"><span class="amount-text">{{row.item.SNAP_COIN_PRICE}}g</span></td>
                <td class="order-recipient"><span>{{row.item.RECIPIENT_NM}}</span></td>
                <td class="order-phone"><span>{{convert_phone(row.item.PHONE)}}</span></td>
                <td class="order-national-id"><span>{{row.item.KO_NATIONAL_ID || '-'}}</span></td>
                <td class="order-userid"><span>{{row.item.USER_ID}}</span></td>
                <td><span>{{row.item.EMAIL || '-'}}</span></td>
                <td class="order-date"><span>{{row.item.CREATE_DT}}</span></td>
                <td class="order-checkbox">
                <v-checkbox
                    v-model="row.item.selected"
                    :disabled="!isEnableCheckBox(row.item.PID)"
                    :input-value="row.item.selected"
                    @change="row.item.selected = $event"
                    hide-details
                    dense
                    color="primary"
                    ></v-checkbox>
                </td>
                <td class="order-state">
                    <v-chip 
                        :color="getStateColor(row.item.PROCESS_STATE)" 
                        small 
                        dark
                        class="state-chip"
                    >
                        {{getStateText(row.item.PROCESS_STATE)}}
                    </v-chip>
                </td>
                <td class="order-action">
                    <v-btn 
                    width="100px"
                    color="primary"
                    class='white--text'
                    small
                    @click="OnClick_ShowPopup_EditCoin(row.item)">상세</v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
    </div>
        </v-list-item-group>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog_popup"
      max-width="800"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
    <v-card class="order-detail-card">
        <v-card-title class="order-detail-header">
            <v-icon left color="white" size="24">mdi-account-circle</v-icon>
            <span class="header-title">주문 상세 정보</span>
            <v-spacer></v-spacer>
            <v-chip small color="primary" dark>{{dialog_selected_item.USER_ID}}</v-chip>
        </v-card-title>
        <v-card-text class="pa-6">
            <div class="order-date-badge mb-4">
                <v-icon left small color="primary">mdi-calendar-clock</v-icon>
                <span class="date-text">주문일시: {{dialog_selected_item.CREATE_DT}}</span>
            </div>

            <v-card outlined class="mb-4 info-card">
                <v-card-subtitle class="info-section-title">
                    <v-icon left size="18">mdi-map-marker</v-icon>
                    배송 정보
                </v-card-subtitle>
                <v-card-text>
                    <v-row class="info-row">
                        <v-col cols="12" sm="3" class="info-label">주소</v-col>
                        <v-col cols="12" sm="9" class="info-value address-value">
                            {{ [dialog_selected_item.ZIPCODE ? '(' + dialog_selected_item.ZIPCODE + ')' : '', dialog_selected_item.ADDRESS, dialog_selected_item.ADDRESS_DETAIL].filter(Boolean).join(' ') || '-' }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <v-row class="info-row">
                        <v-col cols="12" sm="3" class="info-label">수취자</v-col>
                        <v-col cols="12" sm="9" class="info-value">
                            {{ dialog_selected_item.RECIPIENT_NM || '-' }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <v-row class="info-row">
                        <v-col cols="12" sm="3" class="info-label">전화번호</v-col>
                        <v-col cols="12" sm="9" class="info-value">
                            {{ convert_phone(dialog_selected_item.PHONE) || '-' }}
                        </v-col>
                    </v-row>
                    <v-divider v-if="dialog_selected_item.KO_NATIONAL_ID" class="my-2"></v-divider>
                    <v-row v-if="dialog_selected_item.KO_NATIONAL_ID" class="info-row">
                        <v-col cols="12" sm="3" class="info-label">주민등록번호</v-col>
                        <v-col cols="12" sm="9" class="info-value">
                            {{ dialog_selected_item.KO_NATIONAL_ID }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-4 info-card">
                <v-card-subtitle class="info-section-title">
                    <v-icon left size="18">mdi-weight</v-icon>
                    주문 정보
                </v-card-subtitle>
                <v-card-text>
                    <v-row class="info-row">
                        <v-col cols="12" sm="3" class="info-label">무게</v-col>
                        <v-col cols="12" sm="9" class="info-value">
                            <span class="amount-highlight">{{dialog_selected_item.SNAP_COIN_PRICE}}g</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-4 info-card">
                <v-card-subtitle class="info-section-title">
                    <v-icon left size="18">mdi-clipboard-check</v-icon>
                    처리 정보
                </v-card-subtitle>
                <v-card-text>
                    <v-row class="info-row align-center">
                        <v-col cols="12" sm="3" class="info-label">처리상태</v-col>
                        <v-col cols="12" sm="9">
                            <v-select
                                v-if="dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '' || dialog_selected_item.PROCESS_STATE == 'WAIT_DELIVERY' || dialog_selected_item.PROCESS_STATE == 'DELIVERING'"
                                v-model="dropdown_selected"
                                :items="dropdown_items"
                                item-text="text"
                                item-value="value"
                                label="상태 선택"
                                outlined
                                dense
                                hide-details
                                color="primary"
                            ></v-select>
                            <v-chip 
                                v-else
                                :color="getStateColor(dialog_selected_item.PROCESS_STATE)" 
                                dark
                                class="state-chip-large"
                            >
                                {{ getStateText(dialog_selected_item.PROCESS_STATE) }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <v-row class="info-row">
                        <v-col cols="12" sm="3" class="info-label">처리일시</v-col>
                        <v-col cols="12" sm="9" class="info-value">
                            {{ dialog_selected_item.DISPATCH_DT || '미처리' }}
                        </v-col>
                    </v-row>
                    <!-- 배송중 처리: 배송사(기본 대한통운)·송장번호 입력 -->
                    <template v-if="dropdown_selected == 'DELIVERING' && (dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '' || dialog_selected_item.PROCESS_STATE == 'WAIT_DELIVERY' || dialog_selected_item.PROCESS_STATE == 'DELIVERING')">
                        <v-divider class="my-2"></v-divider>
                        <v-row class="info-row">
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    label="배송사"
                                    v-model="dialog_delivery_company"
                                    outlined
                                    dense
                                    color="primary"
                                    hint="기본 대한통운 (변경 가능)"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field
                                    label="송장번호 *"
                                    v-model="dialog_tracking_no"
                                    outlined
                                    dense
                                    color="primary"
                                    :hint="dialog_selected_item.PROCESS_STATE == 'DELIVERING' ? '이미 배송중 — 저장 시 송장정보만 수정됩니다' : '배송중 처리 시 필수'"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <!-- 배송중/배송완료: 저장된 배송정보 표시 -->
                    <template v-else-if="dialog_selected_item.TRACKING_NO || dialog_selected_item.DELIVERY_COMPANY">
                        <v-divider class="my-2"></v-divider>
                        <v-row class="info-row">
                            <v-col cols="12" sm="3" class="info-label">배송정보</v-col>
                            <v-col cols="12" sm="9" class="info-value">
                                {{ dialog_selected_item.DELIVERY_COMPANY || '-' }} / {{ dialog_selected_item.TRACKING_NO || '송장번호 미입력' }}
                            </v-col>
                        </v-row>
                    </template>
                    <v-divider v-if="dropdown_selected == 'CANCEL' && (dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '' || dialog_selected_item.PROCESS_STATE == 'WAIT_DELIVERY' || dialog_selected_item.PROCESS_STATE == 'DELIVERING')" class="my-2"></v-divider>
                    <v-row v-if="dropdown_selected == 'CANCEL' && (dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '' || dialog_selected_item.PROCESS_STATE == 'WAIT_DELIVERY' || dialog_selected_item.PROCESS_STATE == 'DELIVERING')" class="info-row">
                        <v-col cols="12">
                            <v-text-field 
                                label="취소 환불사유"
                                v-model="dialog_cancel_commment" 
                                outlined
                                dense
                                color="error"
                                hint="취소 처리 시 사유를 입력해주세요"
                                persistent-hint
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider v-if="dialog_selected_item.PROCESS_STATE == 'CANCEL'" class="my-2"></v-divider>
                    <v-row v-if="dialog_selected_item.PROCESS_STATE == 'CANCEL'" class="info-row">
                        <v-col cols="12" sm="3" class="info-label">취소사유</v-col>
                        <v-col cols="12" sm="9" class="info-value cancel-reason">
                            {{ dialog_selected_item.COMMENT || '-' }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            outlined
            @click="OnClick_ClosePopup"
            class="mr-2"
          >
            <v-icon left small>mdi-close</v-icon>
            닫기
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="OnClick_EditProductCoin"
            :disabled="!dropdown_selected || !(dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == '' || dialog_selected_item.PROCESS_STATE == 'WAIT_DELIVERY' || dialog_selected_item.PROCESS_STATE == 'DELIVERING')"
          >
            <v-icon left small>mdi-check</v-icon>
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 일괄 상태변경 다이얼로그 -->
    <v-dialog
      v-model="showBulkStateDialog"
      max-width="500"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="headline" style="background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%); color: white;">
          <v-icon left color="white">mdi-format-list-bulleted</v-icon>
          일괄 상태변경
        </v-card-title>
        <v-card-text class="pa-6">
          <div class="mb-4">
            <v-chip color="info" dark>
              선택된 항목: {{ selectedCount }}개
            </v-chip>
          </div>
          <v-select
            v-model="bulk_state_selected"
            :items="bulk_state_items"
            item-text="text"
            item-value="value"
            label="변경할 상태 선택"
            outlined
            dense
            color="primary"
            class="mb-4"
          ></v-select>
          <v-text-field
            v-if="bulk_state_selected == 'CANCEL'"
            v-model="bulk_cancel_comment"
            label="취소 사유"
            outlined
            dense
            color="error"
            hint="취소 처리 시 사유를 입력해주세요"
            persistent-hint
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            outlined
            @click="closeBulkStateDialog"
            class="mr-2"
          >
            <v-icon left small>mdi-close</v-icon>
            취소
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="updateBulkState"
            :disabled="!bulk_state_selected || (bulk_state_selected == 'CANCEL' && (!bulk_cancel_comment || bulk_cancel_comment.trim() == ''))"
          >
            <v-icon left small>mdi-check</v-icon>
            적용
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'GoldOrderList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [            
            { text: '주문번호', value: 'pid', sortable: false },
            { text: '주소', value: 'address', sortable: false },
            { text: '골드 상품', value: 'gold_pid', sortable: false },
            { text: '수취자', value: 'recipient_nm', sortable: false },
            { text: '전화번호', value: 'phone', sortable: false },
            { text: '주민등록번호', value: 'ko_national_id', sortable: false },
            { text: '유저아이디', value: 'user_id', sortable: false },
            { text: '이메일', value: 'email', sortable: false },
            { text: '주문일시', value: 'datetime', sortable: false },
            { text: '선택', value: 'select', sortable: false },
            { text: '상태', value: 'state', sortable: false },
            { text: '관리', value: 'manage', sortable: false },
        ],
        order_list:[],
        stateTab: 0, // 0: 진행중, 1: 진행 완료
        total_count:0,
        search_keyword:'',

        dialog_selected_item: {},
        dialog_popup:false,
        dialog_cancel_commment:'',
        dialog_delivery_company:'대한통운',
        dialog_tracking_no:'',
        enable_check_list: {},

        dropdown_items: [
            { value: 'WAIT_DELIVERY', text: '배송 대기' },
            { value: 'DELIVERING', text: '배송중' },
            { value: 'DONE', text: '배송완료' },
            { value: 'CANCEL', text: '취소' }
        ],
        dropdown_selected: null,
        dropdown_open: false,
        showBulkStateDialog: false,
        bulk_state_selected: null,
        bulk_cancel_comment: '',
        bulk_state_items: [
            { value: 'WAIT_DELIVERY', text: '배송 대기' },
            { value: 'DELIVERING', text: '배송중' },
            { value: 'DONE', text: '배송완료' },
            { value: 'CANCEL', text: '취소' }
        ],
    }),

    created()
    {
        console.log("TEST");
        this.Load_OrderList();
    },

    methods:{
        ...mapActions([
            "CARRYGOLD_GET_GOLD_ORDER_LIST",
            "CARRYGOLD_SEARCH_GOLD_ORDER_LIST",
            "CARRYGOLD_EDIT_GOLD_ORDER_STATE",
        ]),
        async Load_OrderList()
        {
            // 이미 로딩 중이면 중복 호출 방지
            if (this.loadingData) {
                console.log("이미 로딩 중입니다. 중복 호출 방지");
                return;
            }
            
            try {
                this.loadingData = true;
                const body_data = await this.CARRYGOLD_GET_GOLD_ORDER_LIST({count:200});
                this.order_list = body_data.order_list;
                //enable_check_list
                this.enable_check_list = {};
                this.order_list.forEach(element => {
                    
                    if(!this.isAfterThisMonday(element.CREATE_DT) && element.PROCESS_STATE == 'WAIT'){ 
                        this.$set(this.enable_check_list, element.PID, true);
                    }
                });
                console.log(JSON.stringify(this.order_list));
                return body_data;
            } catch (error) {
                console.error("주문 리스트 로드 실패:", error);
                throw error;
            } finally {
                this.loadingData = false;
            }
        },
        OnClick_SearchUser()
        {
            this.CARRYGOLD_SEARCH_GOLD_ORDER_LIST({user_id:this.search_keyword}).then((body_data)=>{
                this.order_list = body_data.order_list;
                console.log(JSON.stringify(this.order_list));
            });
        },
 
        async OnClick_EditProductCoin() {
            // 이미 처리 중이면 중복 호출 방지
            if (this.loadingData) {
                return;
            }
            
            let pid = this.dialog_selected_item.PID;
            let process_state = this.dropdown_selected;
            let comment = '';

            // 가드: 변경할 상태가 선택되지 않았으면 호출 자체를 막는다.
            // (CANCEL/DONE 등 종료 상태에서는 dropdown이 렌더링되지 않으므로 null로 들어와 빈 값이 백엔드에 전송되던 버그 방지)
            if (!process_state) {
                alert("변경할 상태를 선택해주세요.");
                return;
            }

            // 취소일 때만 코멘트 필수
            if(process_state == "CANCEL"){
                comment = this.dialog_cancel_commment;
                if(!comment || comment.trim() == ''){
                    alert("취소처리에는 사유 작성이 필요합니다.");
                    return;
                }
            } else {
                // DELIVERING, DONE은 코멘트 불필요
                comment = '';
            }

            // 배송중: 송장번호 필수, 배송사 기본 대한통운
            let delivery_company;
            let tracking_no;
            if (process_state == 'DELIVERING') {
                delivery_company = (this.dialog_delivery_company || '').trim() || '대한통운';
                tracking_no = (this.dialog_tracking_no || '').trim();
                if (!tracking_no) {
                    alert("배송중 처리에는 송장번호 입력이 필요합니다.");
                    return;
                }
            }
            
            try {
                this.loadingData = true;
                const result = await this.CARRYGOLD_EDIT_GOLD_ORDER_STATE({pid , process_state , comment, delivery_company, tracking_no});
                
                // 상태 변경 성공 후 해당 항목만 업데이트 (전체 리스트 다시 불러오지 않음)
                const itemIndex = this.order_list.findIndex(item => item.PID === pid);
                if (itemIndex !== -1) {
                    // 기존 항목의 상태만 업데이트
                    this.$set(this.order_list[itemIndex], 'PROCESS_STATE', process_state);
                    if (comment) {
                        this.$set(this.order_list[itemIndex], 'COMMENT', comment);
                    }
                    if (process_state == 'DELIVERING') {
                        this.$set(this.order_list[itemIndex], 'DELIVERY_COMPANY', delivery_company);
                        this.$set(this.order_list[itemIndex], 'TRACKING_NO', tracking_no);
                    }
                    // DISPATCH_DT는 서버에서 업데이트되므로 필요시 전체 리스트 다시 불러오기
                    // 하지만 일단은 상태만 업데이트하고 나중에 필요하면 전체 리스트 불러오기
                }
                
                // 팝업 내 아이템도 갱신
                if (itemIndex !== -1) {
                    this.dialog_selected_item = { ...this.order_list[itemIndex] };
                }
                
                // enable_check_list 업데이트 (상태가 WAIT가 아니면 체크박스 비활성화)
                if (process_state !== 'WAIT') {
                    this.$delete(this.enable_check_list, pid);
                }
                
                alert("상태가 변경되었습니다.");
                this.$root.$emit('menu-dot:refresh');   // 금교환 처리 후 메뉴 레드닷 갱신
                this.OnClick_ClosePopup();
            } catch (error) {
                console.error("상태 변경 실패:", error);
                alert("상태 변경에 실패했습니다. 다시 시도해주세요.");
            } finally {
                this.loadingData = false;
            }
        },
        OnClick_ShowPopup_EditCoin(item)
        {
            // 다이얼로그가 의존하는 모든 상태를 매번 새로 초기화한다.
            // 직전에 열었던 다른 행의 dropdown 선택/취소 사유/펼침 상태가 새 행에 새는 것을 방지.
            // dialog_selected_item 은 참조가 아닌 스프레드 복사로 — 다이얼로그 내부 수정이 order_list 원본을 오염시키지 않도록 분리.
            this.dialog_selected_item = item ? { ...item } : {};
            this.dropdown_selected = null;
            this.dropdown_open = false;
            this.dialog_cancel_commment = '';
            // 배송정보: 저장된 값 프리필 (배송사 기본 대한통운). 이미 배송중이면 바로 송장 수정 가능하게 배송중 선택.
            this.dialog_delivery_company = (item && item.DELIVERY_COMPANY) || '대한통운';
            this.dialog_tracking_no = (item && item.TRACKING_NO) || '';
            if (item && item.PROCESS_STATE == 'DELIVERING') this.dropdown_selected = 'DELIVERING';
            this.dialog_popup = true;
        },
        OnClick_ClosePopup()
        {
            this.dialog_popup = false;
            // 닫을 때도 즉시 비우면 닫힘 애니메이션 중에 빈 다이얼로그가 깜빡일 수 있어
            // 다음 OnClick_ShowPopup_EditCoin 호출에서 일괄 초기화한다.
        },
        formatCoin(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString();
        },
        toggleDropdown() {
            this.dropdown_open = !this.dropdown_open
        },
        selectItem(item) {
            this.dropdown_selected = item
            this.dropdown_open = false
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdown_open = false
            }
        },
       convert_phone(phone) {
            if (!phone) { return ''; }
            
            // 숫자만 남기기
            phone = phone.replace(/\D/g, '');
            
            // 11자리 (예: 010-1234-5678)
            if (phone.length === 11) {
                return phone.substring(0, 3) + '-' + phone.substring(3, 7) + '-' + phone.substring(7);
            }
            
            // 10자리 (예: 02-1234-5678 또는 031-123-4567)
            if (phone.length === 10) {
                return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6);
            }
            
            // 그 외는 원본 반환
            return phone;
        },
        calc_gold_weight(pid){
            // GOLD_PID에 따른 무게(1g 단위) 계산 (백엔드에서 실제 값 확인 필요)
            // 일단 기본값으로 설정, 나중에 실제 상품 정보에 맞게 수정 필요
            if(pid == 170)
                return 1;
            else if(pid == 171)
                return 2;   
            else if(pid == 172)
                return 4;   
            else if(pid == 12)
                return 10;   
            else
                return 0;

        },
        getStateColor(state) {
            if (!state || state === '') return 'blue-grey';  // 빈 값도 WAIT(주문 완료)로 처리
            if (state == 'WAIT') return 'blue-grey';          // 주문 완료
            if (state == 'WAIT_DELIVERY') return 'orange';    // 배송 대기
            if (state == 'DELIVERING') return 'blue';         // 배송중
            if (state == 'DONE') return 'green';              // 배송완료
            if (state == 'CANCEL') return 'red';              // 취소
            if (state == 'USER_CANCEL') return 'deep-orange'; // 유저 취소
            return 'grey'; // 알 수 없는 상태
        },
        getStateText(state) {
            if (!state || state === '') return '주문 완료'; // 빈 값은 WAIT(주문 완료)로 표시
            if (state == 'WAIT') return '주문 완료';
            if (state == 'WAIT_DELIVERY') return '배송 대기';
            if (state == 'DELIVERING') return '배송중';
            if (state == 'DONE') return '배송완료';
            if (state == 'CANCEL') return '취소';
            if (state == 'USER_CANCEL') return '유저 취소';
            return state;
        },
        isAfterThisMonday(dateStr) {
            if (!dateStr) return false;
            const inputDate = new Date(dateStr.replace(/-/g, '/'));
            const now = new Date();
            // Get this week's Monday 00:00:00
            const day = now.getDay();
            const diff = now.getDate() - day + (day === 0 ? -6 : 1); // Monday as start of week
            const monday = new Date(now.setDate(diff));
            monday.setHours(0, 0, 0, 0);
            return inputDate >= monday;
        },
        isEnableCheckBox(pid)
        {
            let isEnableState = Object.prototype.hasOwnProperty.call(this.enable_check_list, pid);
            return isEnableState;            
        },
        isInProgressState(state) {
            return !state || state === 'WAIT' || state === 'WAIT_DELIVERY' || state === 'DELIVERING';
        },
        checkBoxEnable_all()
        {
            // 현재 보고 있는 탭의 항목만 선택
            this.visibleOrderList.forEach(element => {
                if(this.isEnableCheckBox(element.PID)){
                    this.$set(element, 'selected', true);
                }
            });
        },
        closeBulkStateDialog() {
            this.showBulkStateDialog = false;
            this.bulk_state_selected = null;
            this.bulk_cancel_comment = '';
        },
        async updateBulkState() {
            // 이미 처리 중이면 중복 호출 방지
            if (this.loadingData) {
                return;
            }
            
            const selected_pids = this.order_list
                .filter((item) => item.selected)
                .map((item) => item.PID);

            if (selected_pids.length === 0) {
                alert("선택된 항목이 없습니다.");
                return;
            }

            if (!this.bulk_state_selected) {
                alert("변경할 상태를 선택해주세요.");
                return;
            }

            // 취소일 때 코멘트 확인
            let comment = '';
            if (this.bulk_state_selected == 'CANCEL') {
                comment = this.bulk_cancel_comment;
                if (!comment || comment.trim() == '') {
                    alert("취소처리에는 사유 작성이 필요합니다.");
                    return;
                }
            }

            const stateText = this.bulk_state_items.find(item => item.value === this.bulk_state_selected)?.text || this.bulk_state_selected;
            if (!confirm(`선택된 ${selected_pids.length}개 항목을 "${stateText}" 상태로 변경하시겠습니까?`)) {
                return;
            }

            try {
                this.loadingData = true;
                const failed = [];
                
                // 병렬 처리로 성능 개선 (순차 처리 대신)
                const promises = selected_pids.map(pid => 
                    this.CARRYGOLD_EDIT_GOLD_ORDER_STATE({
                        pid: pid,
                        process_state: this.bulk_state_selected,
                        comment: comment
                    }).catch((e) => {
                        failed.push({ pid: pid, reason: e });
                        return null; // 실패해도 계속 진행
                    })
                );
                
                await Promise.all(promises);
                
                // 성공한 항목들만 로컬 상태 업데이트
                selected_pids.forEach(pid => {
                    const itemIndex = this.order_list.findIndex(item => item.PID === pid);
                    if (itemIndex !== -1 && !failed.find(f => f.pid === pid)) {
                        this.$set(this.order_list[itemIndex], 'PROCESS_STATE', this.bulk_state_selected);
                        if (comment) {
                            this.$set(this.order_list[itemIndex], 'COMMENT', comment);
                        }
                        // 선택 해제
                        this.$set(this.order_list[itemIndex], 'selected', false);
                        // enable_check_list 업데이트
                        if (this.bulk_state_selected !== 'WAIT') {
                            this.$delete(this.enable_check_list, pid);
                        }
                    }
                });
                
                if (failed.length > 0) {
                    const msg = failed.map((f) => `PID ${f.pid}: ${String(f.reason)}`).join("\n");
                    alert(`일부 항목 처리 실패:\n${msg}`);
                } else {
                    alert(`${selected_pids.length}개 항목이 "${stateText}" 상태로 변경되었습니다.`);
                }
                
                this.closeBulkStateDialog();
            } catch (error) {
                console.error("일괄 상태 변경 실패:", error);
                alert("상태 변경 중 오류가 발생했습니다. 다시 시도해주세요.");
            } finally {
                this.loadingData = false;
            }
        }
 
    },
    watch: {
        // 탭 전환 시 선택 해제 — 안 보이는 탭의 체크가 일괄 상태변경에 섞이지 않도록
        stateTab() {
            this.order_list.forEach((item) => {
                if (item.selected) this.$set(item, 'selected', false);
            });
        },
    },
    computed: {
        // 진행중: 주문 완료(WAIT, 빈값 포함)·배송 대기·배송중 — 주문번호(PID) 오름차순, 먼저 들어온 주문부터 처리
        inProgressList() {
            return this.order_list
                .filter((item) => this.isInProgressState(item.PROCESS_STATE))
                .slice()
                .sort((a, b) => Number(a.PID) - Number(b.PID));
        },
        // 진행 완료: 배송완료·취소·유저 취소 (기존 정렬 그대로)
        completedList() {
            return this.order_list.filter((item) => !this.isInProgressState(item.PROCESS_STATE));
        },
        visibleOrderList() {
            return this.stateTab === 0 ? this.inProgressList : this.completedList;
        },
        hasSelectedItems() {
            return this.order_list.some(item => item.selected);
        },
        selectedCount() {
            return this.order_list.filter(item => item.selected).length;
        }
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
/* 테이블 스타일 */
.order-table {
    border-radius: 8px;
    overflow: hidden;
}

.order-table >>> thead th {
    background-color: #f5f5f5 !important;
    font-weight: 400 !important;
    color: #000000 !important;
    padding: 16px 8px !important;
}

.order-table >>> tbody tr {
    transition: background-color 0.2s;
}

.order-table >>> tbody tr:hover {
    background-color: #f9f9f9 !important;
}

.order-table >>> tbody tr.old-order {
    background-color: #fafafa !important;
}

.order-pid {
    width: 80px;
    text-align: center;
}

.order-address {
    min-width: 260px;
    width: 300px;
    max-width: 320px;
    padding: 12px 8px !important;
    word-break: break-word;
}

.order-amount {
    text-align: right;
    padding-right: 16px !important;
}

.amount-text {
    font-size: 14px;
}

.order-date {
    font-size: 13px;
}

.order-state {
    text-align: center;
}

.state-chip {
    min-width: 70px;
}

.order-action {
    text-align: center;
}

/* 팝업 스타일 */
.order-detail-card {
    border-radius: 12px;
    overflow: hidden;
}

.order-detail-header {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    color: white;
    padding: 20px 24px;
}

.header-title {
    font-size: 20px;
    font-weight: 600;
    margin-left: 8px;
}

.order-date-badge {
    background: #e3f2fd;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
}

.date-text {
    font-weight: 600;
    color: #1976d2;
    font-size: 14px;
}

.info-card {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
}

.info-section-title {
    background: #f5f5f5;
    font-weight: 600;
    color: #424242;
    padding: 12px 16px !important;
    border-bottom: 2px solid #e0e0e0;
}

.info-row {
    padding: 8px 0;
}

.info-label {
    font-weight: 600;
    color: #757575;
    font-size: 14px;
    padding-top: 12px;
    padding-bottom: 12px;
}

.info-value {
    font-weight: 500;
    color: #424242;
    font-size: 14px;
    padding-top: 12px;
    padding-bottom: 12px;
}

.address-value {
    word-break: break-word;
    line-height: 1.6;
}

.amount-highlight {
    font-size: 18px;
    font-weight: 700;
    color: #1976d2;
}

.state-chip-large {
    font-weight: 600;
    font-size: 14px;
    padding: 8px 16px;
}

.cancel-reason {
    color: #d32f2f;
    font-weight: 500;
}

/* 버튼 스타일 개선 */
.v-btn {
    text-transform: none;
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* 툴바 스타일 */
.v-toolbar {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

</style>
